/** @format */

import React, { PureComponent } from 'react';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../../../assets/jss/adescom/adescomStyle';
import HeaderCheckBoxSelectList, { HeaderListProps } from './HeaderCheckBoxSelectList';
import { ApiOperationStateHelper } from '../ApiOperationStateHelper';

class HeaderApiOerationState extends PureComponent<HeaderListProps> {
    private apiOperationStateHelper = new ApiOperationStateHelper();

    handleChange = (numbers: Array<number>): void => {
        const { handleChange, fieldName } = this.props;
        handleChange(fieldName, numbers, this.apiOperationStateHelper.getStatus());
    };

    render(): React.ReactNode {
        const { fieldName } = this.props;
        return (
            <HeaderCheckBoxSelectList handleChange={this.handleChange} elements={this.apiOperationStateHelper.getStatus()} fieldName={fieldName} />
        );
    }
}

export default compose<any, any>(withStyles(adescomStyle))(HeaderApiOerationState);
